/** @jsxImportSource @emotion/react */

import MSAGRead, { loadRecord as loadMsagRead } from "pages/MSAG/MSAGRead";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Dashboard from "./pages/Dashboard";

import Layout from "./components/Layout/Layout";

import ALIRecords from "pages/ALI/ALIRecords";

import ErrorPage from "components/Layout/Error";
import ALIRecordsView from "pages/ALI/index";
import Home from "pages/Home";
// import Discrepancies from "pages/Discrepancies/Discrepancies";
// import MSAGView, { MSAGRecords } from "./pages/MSAG";
import { UserContext } from "context/UserContext";
import ALIRead, { loadRecord as loadViewRecord } from "pages/ALI/ALIRead";
import ALIErrorRecordsView from "pages/ALIErrors";

import ALIDelete from "pages/ALI/ALIDelete";
import ALIEdit, { ALICreate, ALIMigrate } from "pages/ALI/ALIForm";
import BulkChangeRequest from "pages/ALI/BulkChangeRequest";
import ALIErrorDelete from "pages/ALIErrors/ALIErrorDelete";
import ALIErrorEdit from "pages/ALIErrors/ALIErrorEdit";
import ALIErrorRead, {
  loadRecord as loadViewAliErrorRecord,
} from "pages/ALIErrors/ALIErrorRead";
import ALIErrorRecords from "pages/ALIErrors/ALIErrorRecords";
import ALILogsView from "pages/ALILog";
import ALILogsTable from "pages/ALILog/ALILogsTable";
import DiscrepancyRecordsView from "pages/Discrepancies";
import DiscrepancyRecords from "pages/Discrepancies/DiscrepancyRecords";
import ViewDiscrepancy, {
  loadDiscrepancy,
} from "pages/Discrepancies/ViewDiscrepancy";
import ELTRecordsView from "pages/ELT";
import ELTRecords from "pages/ELT/ELTRecords";
import Login from "pages/login";
import MSAGRecordsView from "pages/MSAG";
import MSAGEdit from "pages/MSAG/MSAGEdit";
import MSAGRecords from "pages/MSAG/MSAGRecords";
import Profile from "pages/Profile";
import VersionHistory from "pages/VersionHistory";
import { useContext } from "react";

const permissionMapping = {
  global: [
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/home",
      element: <Home />,
    },
    {
      element: <Layout />,
      children: [
        {
          path: "/version-history",
          element: <VersionHistory />,
          errorElement: <ErrorPage />,
          id: "version-history",
        },
      ],
    },
    {
      element: <Layout />,
      children: [
        {
          path: "/profile",
          element: <Profile />,
          errorElement: <ErrorPage />,
          id: "profile",
        },
      ],
    },
    {
      path: "*",
      element: <ErrorPage />,
    },
  ],
  "foresite:dashboard": [
    {
      element: <Layout />,
      children: [
        {
          path: "/dashboard",
          element: <Dashboard />,
        },
      ],
    },
  ],

  "foresite:ali:view": [
    {
      element: <Layout />,
      children: [
        {
          path: "/ali-records",
          element: <ALIRecordsView />,
          errorElement: <ErrorPage />,
          children: [
            {
              index: true,
              element: <ALIRecords />,
            },
            {
              path: "view/:cpn",
              id: "view_cpn",
              element: <ALIRead />,
              loader: loadViewRecord,
              errorElement: <ErrorPage />,
            },
          ],
        },
      ],
    },
  ],
  "foresite:ali:write": [
    {
      element: <Layout />,
      children: [
        {
          path: "/ali-records",
          element: <ALIRecordsView />,
          errorElement: <ErrorPage />,
          children: [
            {
              index: true,
              element: <ALIRecords />,
            },
            {
              path: "new",
              element: <ALICreate />,
            },
            {
              path: "edit/:cpn",
              id: "edit_cpn",
              element: <ALIEdit />,
              loader: loadViewRecord,
              errorElement: <ErrorPage />,
            },
            {
              path: "delete/:cpn",
              id: "delete_cpn",
              loader: loadViewRecord,
              element: <ALIDelete />,
              errorElement: <ErrorPage />,
            },
            {
              path: "migrate",
              id: "migrate",
              element: <ALIMigrate />,
            },
          ],
        },
      ],
    },
  ],
  "foresite:ali:requestChange": [
    {
      element: <Layout />,
      children: [
        {
          path: "/ali-records",
          element: <ALIRecordsView />,
          errorElement: <ErrorPage />,
          children: [
            {
              index: true,
              element: <ALIRecords />,
            },
            {
              path: "edit/:cpn",
              id: "edit_cpn",
              element: <ALIEdit />,
              loader: loadViewRecord,
              errorElement: <ErrorPage />,
            },
          ],
        },
        {
          path: "/ali-records/bulk-change-request",
          element: <BulkChangeRequest />,
        },
      ],
    },
  ],
  "foresite:ali_error:view": [
    {
      element: <Layout />,
      children: [
        {
          path: "/ali-errors",
          element: <ALIErrorRecordsView />,
          errorElement: <ErrorPage />,
          children: [
            {
              index: true,
              element: <ALIErrorRecords />,
            },
            {
              path: "view/:idx",
              id: "view_ali_error_idx",
              element: <ALIErrorRead />,
              loader: loadViewAliErrorRecord,
              errorElement: <ErrorPage />,
            },
          ],
        },
      ],
    },
  ],
  "foresite:ali_error:write": [
    {
      element: <Layout />,
      children: [
        {
          path: "/ali-errors",
          element: <ALIErrorRecordsView />,
          errorElement: <ErrorPage />,
          children: [
            {
              index: true,
              element: <ALIErrorRecords />,
            },
            {
              path: "edit/:idx",
              id: "edit_ali_error_idx",
              element: <ALIErrorEdit />,
              loader: loadViewAliErrorRecord,
              errorElement: <ErrorPage />,
            },
            {
              path: "delete/:idx",
              id: "delete_ali_error_idx",
              loader: loadViewAliErrorRecord,
              element: <ALIErrorDelete />,
              errorElement: <ErrorPage />,
            },
          ],
        },
      ],
    },
  ],
  "foresite:msag:view": [
    {
      element: <Layout />,
      children: [
        {
          path: "/msag-records",
          element: <MSAGRecordsView />,
          handle: { scrollMode: "heading" },
          children: [
            {
              index: true,
              element: <MSAGRecords />,
            },
            {
              path: "view/:id",
              id: "view_msag_id",
              element: <MSAGRead />,
              loader: loadMsagRead,
              errorElement: <ErrorPage />,
            },
          ],
        },
      ],
    },
  ],
  "foresite:msag:requestChange": [
    {
      element: <Layout />,
      children: [
        {
          path: "/msag-records",
          element: <MSAGRecordsView />,
          handle: { scrollMode: "heading" },
          children: [
            {
              index: true,
              element: <MSAGRecords />,
            },
            {
              path: "edit/:id",
              id: "edit_msag_id",
              element: <MSAGEdit />,
              loader: loadMsagRead,
              errorElement: <ErrorPage />,
            },
          ],
        },
      ],
    },
  ],
  "foresite:discrep:updateByJurisdiction": [
    {
      element: <Layout />,
      children: [
        {
          path: "/discrepancies",
          element: <DiscrepancyRecordsView />,
          handle: { scrollMode: "heading" },
          children: [
            {
              index: true,
              element: <DiscrepancyRecords />,
            },
            {
              path: "view/:id",
              id: "view_discrepancy_id",
              element: <ViewDiscrepancy />,
              loader: loadDiscrepancy,
              errorElement: <ErrorPage />,
            },
          ],
        },
      ],
    },
  ],
  "foresite:discrep:updateByCarrier": [
    {
      element: <Layout />,
      children: [
        {
          path: "/discrepancies",
          element: <DiscrepancyRecordsView />,
          handle: { scrollMode: "heading" },
          children: [
            {
              index: true,
              element: <DiscrepancyRecords />,
            },
            {
              path: "view/:id",
              id: "view_discrepancy_id",
              element: <ViewDiscrepancy />,
              loader: loadDiscrepancy,
              errorElement: <ErrorPage />,
            },
          ],
        },
      ],
    },
  ],
  "foresite:ELT:view": [
    {
      element: <Layout />,
      children: [
        {
          path: "/elt-records",
          element: <ELTRecordsView />,
          handle: { scrollMode: "heading" },
          children: [
            {
              index: true,
              element: <ELTRecords />,
            },
          ],
        },
      ],
    },
  ],
  "foresite:ali_log:view": [
    {
      element: <Layout />,
      children: [
        {
          path: "/ali-logs",
          element: <ALILogsView />,
          errorElement: <ErrorPage />,
          children: [
            {
              index: true,
              element: <ALILogsTable />,
            },
            // {
            //   path: "view/:idx",
            //   id: "view_ali_log_idx",
            //   element: <ALILogsRead />,
            //   loader: loadViewAliErrorRecord,
            //   errorElement: <ErrorPage />,
            // },
          ],
        },
      ],
    },
  ],
};

function getRoutes(userPermissions: string[] | undefined) {
  let routes = [...permissionMapping.global];

  if (userPermissions) {
    routes = [
      ...routes,
      ...userPermissions
        .map((perm) => permissionMapping[perm])
        .filter(Boolean)
        .flat(),
    ];
  }

  // console.log("Constructed routes:", routes);

  return createBrowserRouter(routes);
}

const App = () => {
  const { user } = useContext(UserContext);

  // const allPermissions = [
  //   // dashboard
  //   "foresite:dashboard",

  //   // ali records
  //   "foresite:ali:view",
  //   "foresite:ali:write",
  //   "foresite:ali:requestChange",
  //   "foresite:ali:addlData:write",

  //   // ali errors
  //   "foresite:ali_error:view",
  //   "foresite:ali_error:write",

  //   // msag records
  //   "foresite:msag:view",
  //   "foresite:msag:requestChange",

  //   // discrepancies
  //   "foresite:discrep:updateByCarrier",
  //   "foresite:discrep:updateByJurisdiction",

  //   // ali logs
  //   "foresite:ali_log:view",

  //   // elt records
  //   "foresite:ELT:view",
  // ];

  //console.log("User permissions:", user?.functions);

  return <RouterProvider router={getRoutes(user?.functions)} />;
};

export default App;
